import { Role } from "@/router/_helper";

const checklist = {
  path: "/checklist",
  name: "checklist",
  component: () =>
    import(
      /* webpackChunkName: "checklist" */ "@/components/checklist/Checklist.vue"
    ),
  meta: { authorize: [Role.ManageSettings], requiresAuth: true },
};

export default checklist;
